import { Button } from 'primereact/button';
import type { MouseEvent, ReactNode } from 'react';
import { cn } from '../ui/cn';

type HeaderIconButtonProps = {
	ariaLabel: string;
	icon?: ReactNode;
	label?: string;
	disabled?: boolean;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
	className?: string;
};

const HeaderIconButton = ({
	ariaLabel,
	icon,
	label,
	disabled,
	onClick,
	className,
}: HeaderIconButtonProps) => {
	return (
		<Button
			aria-label={ariaLabel}
			label={label}
			icon={icon}
			rounded
			disabled={disabled}
			onClick={onClick}
			className={cn(
				'small flex items-center justify-center rounded-full bg-secondaryContainer text-primary transition-colors duration-200 hover:bg-neutralVariant90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
				label ? 'min-w-[108px] gap-2' : 'h-10 w-10',
				className,
			)}
		/>
	);
};

export default HeaderIconButton;
